// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1o_Nj{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;color:#95a1bd;margin-bottom:2.4rem}.-dRfr{color:#0a385a}._1Mna9{fill:#95a1bd;height:24px;height:2.4rem;width:24px;width:2.4rem}._3Dxay{fill:#40bf60}._13yJm{fill:#f65663}._2hcvW{padding:1.2rem 3rem}._2hcvW:nth-child(2n){background-color:#f5f9ff}", ""]);
// Exports
exports.locals = {
	"summary__item": "_1o_Nj",
	"summary__item--active": "-dRfr",
	"summary__icon": "_1Mna9",
	"summary__icon--success": "_3Dxay",
	"summary__icon--error": "_13yJm",
	"errorsList__item": "_2hcvW"
};
module.exports = exports;
